//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { formatDate, convertDuration } from '@/helpers/filters.js'
import userChecks from '~/mixins/userChecks';
export default {
    mixins: [userChecks],
    props: ['resource', 'items'],
    data() { 
        return {
            favorite: false,
        }
    },
    methods: {
        formatDate,
        convertDuration,
        toggleFavo() {
            if (!this.$auth.loggedIn) {
                var alertObj = {};
                alertObj.type = 'info';
                alertObj.message = 'Je kan alleen favorieten toevoegen als je bent ingelogd.';
                return this.$store.commit('alertStore/setAlert', alertObj);
            }
            let data = {
                resource_id: this.resource.id,
                subscribe: 1
            };
            if (this.$auth.loggedIn) {
                data.user_id = this.$auth.user.id;
            } else {
                var alertObj = {};
                alertObj.type = 'info';
                alertObj.message = 'Je moet inloggen om iets aan je favorieten toe te voegen.';
                this.$store.commit('alertStore/setAlert', alertObj);
                return false;    
            }
            if (this.favorite) {
                data.subscribe = 0;
                this.favorite = false;
            } else {
                this.favorite = true;
            }
            this.$store.dispatch('accountStore/toggleFavorite', data);
        },
    }
}
